"use client";

import React from 'react';
import { useMediaQuery } from "react-responsive";
import { useTranslation } from 'react-i18next';
import AboutSectionOneDesktop from './Desktop/AboutSectionOneDesktop';
import AboutSectionOneMobile from './Mobile/AboutSectionOneMobile';

const AboutSectionOne = () => {
  const { t } = useTranslation('translation');
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const title = t("aboutSectionOneTitle");
  const paragraph = t("aboutSectionOneDescription");
  const list1 = t("aboutSectionOneList1");
  const list2 = t("aboutSectionOneList2");
  const list3 = t("aboutSectionOneList3");
  const list4 = t("aboutSectionOneList4");

  return (
    <section id="about" className="pt-16 md:pt-20 lg:pt-28">
      {isMobile ? (
        <AboutSectionOneMobile
          title={title}
          paragraph={paragraph}
          list1={list1}
          list2={list2}
          list3={list3}
          list4={list4}
        />
      ) : (
        <AboutSectionOneDesktop
          title={title}
          paragraph={paragraph}
          list1={list1}
          list2={list2}
          list3={list3}
          list4={list4}
        />
      )}
    </section>
  );
};

export default AboutSectionOne;